import React from "react";

import { LanguagesDataProvider } from "../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { LanguageSpecificationDashboardProvider } from "./context/LanguageSpecificationDashboardProvider";
import { LanguageSpecificationDashboardHeader } from "./LanguageSpecificationDashboardHeader";
import { MappingsListing } from "./mappings/listing/MappingsListing";

export const LanguageSpecificationDashboardPage: React.FC = () => {
    return (
        <LanguageSpecificationDashboardProvider>
            <LanguageSpecificationDashboardHeader />
            <LanguagesDataProvider>
                <MappingsListing />
            </LanguagesDataProvider>
        </LanguageSpecificationDashboardProvider>
    );
};
